import { FunnelChartProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: FunnelChartProps = {
  data: [
    { value: 1000, label: 'visits' },
    { value: 800, label: 'views' },
  ],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as FunnelChartProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
